import * as action_types from './action_types';

export const getRoles = (data) => {
    return {
        type: action_types.GET_ROLES,
        data: data
    }
};

export const getUsers = (data) => {
    return {
        type: action_types.GET_USERS,
        data: data
    }
};


// WEBPACK FOOTER //
// ./src/actions/UsersActions.js